import { connect } from 'react-redux'
import { compose, withProps, withHandlers } from 'recompose'
import { getLocationPathname } from 'selectors/getPageLocation'
import { findTires } from './actions'
import withType from 'components/common/hoc/withType'
import BOTSearchTiresBySizePanel from './BOTSearchTiresBySizePanel'
import { EV_TIRES_BUTTON_LABEL, EV_TIRES_PATH_NAME, SEARCH_TIRES_PURPOSE_TRAILER } from './constants'

const mapStateToProps = state => ({
  searchButtonLabel: getLocationPathname(state).indexOf(EV_TIRES_PATH_NAME) > 0 ? EV_TIRES_BUTTON_LABEL : undefined
})

const withNormalizeProps = withProps(({ purpose }) => ({
  isTrailerPage: purpose === SEARCH_TIRES_PURPOSE_TRAILER
}))

const withSumbitHandler = withHandlers({
  handleShopByTireSizesSubmit: ({ findTires, purpose, queryParams }) => tireSize =>
    findTires({ purpose, queryParams, tireSize })
})

export default compose(
  withType({ type: 'BOTSearchTiresBySizePanel' }),
  connect(mapStateToProps, { findTires }),
  withNormalizeProps,
  withSumbitHandler
)(BOTSearchTiresBySizePanel)
